import React from 'react';
import styles from '../irlObservations2026.module.css';
import { SuggestHeader, SuggestTabs, stripHtmlText, suggestionCardKey } from './shared';

export default function IRL_AI_Review_Review_Suggestions_Contradictions({
    tab,
    tabs,
    onTab,
    onBack,
    items,
    counts,
    reviewMeta,
    onAccept,
    onDismiss,
    onFollowUp,
    busy,
}) {
    return (
        <>
            <SuggestHeader onBack={onBack} meta={reviewMeta} />
            <SuggestTabs tabs={tabs} tab={tab} onTab={onTab} counts={counts} />
            <div className={styles.detailBody}>
                {items.map(item => {
                    const done = item.status === 'ACCEPTED' || item.status === 'DISMISSED';
                    return (
                        <div key={suggestionCardKey(item)} className={styles.contradiction}>
                            <div className={styles.suggestId}>Potential contradiction</div>
                            <div className={styles.splitRow}>
                                <div className={styles.splitBad}>
                                    <p className={styles.splitLabel}>{item.leftLabel}</p>
                                    <p className={styles.responseBody}>{stripHtmlText(item.left)}</p>
                                </div>
                                <div className={styles.splitGood}>
                                    <p className={styles.splitLabel}>{item.rightLabel}</p>
                                    <p className={styles.responseBody}>{stripHtmlText(item.right)}</p>
                                </div>
                            </div>
                            <p className={styles.modalIntro}>{stripHtmlText(item.note)}</p>
                            <div className={styles.actionRow}>
                                <button type="button" className={styles.outlineBtn} onClick={() => onAccept?.(item)} disabled={done || busy}>
                                    {item.status === 'ACCEPTED' ? 'Recorded' : 'Record contradiction'}
                                </button>
                                <button type="button" className={styles.outlineBtn} onClick={() => onFollowUp?.(item)} disabled={item.status === 'DISMISSED' || busy}>
                                    Create follow-up IRL
                                </button>
                                <button type="button" className={styles.mutedBtn} onClick={() => onDismiss?.(item)} disabled={done || busy}>
                                    {item.status === 'DISMISSED' ? 'Dismissed' : 'Dismiss'}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
